import { integrationsApi } from "src/services/integrations";
import { useQueryBuilder } from "../useBuilders";
import { INTEGRATIONS } from "../queryKeys";

export const useIntegrationsQuery = () => {
  return useQueryBuilder([INTEGRATIONS], integrationsApi.fetchIntegrations, false, 0, true);
};